export const isInactiveTab = () => document.hidden;

export const isBlurredDocument = () => !document.hasFocus();
